import InvestorCouponsError from './InvestorCouponsError';
class InvalidCouponId extends InvestorCouponsError {
    couponId;
    constructor(couponId, options) {
        super('The coupon id is invalid', options);
        this.couponId = couponId;
    }
}
export default InvalidCouponId;
